

// functions called on doc ready
$("document").ready(function() {
  initCards();
});


// init functions
function initCards() {
  // get the data for all strategies, and use it to create the cards markup on the page
  $.get('./datavis/data/strategies_full/', function(strategies) {

    strategies.forEach(function(strategy) {
      var target = $("div.card-deck div.row");

      var grid = $("<div>", {"class": "col-md-4 d-flex align-items-stretch"}).appendTo(target);

      var card = $("<div>", {
        "class": "card",
      });
      // when clicking a card, redirect to the datavis
      // it would be better if this were an actual link, but that seems to mess up the even auto-height 
      // behavior of the native card markup
      card.on("click", function() {
        window.location.href = window.location.href + "datavis" + "/?strategy=" + strategy.id
      });
      grid.append(card);

      var image = $("<img>", {
        "class": "card-img-top", 
        "src": strategy.image_src
      });
      card.append(image);

      var body = $("<div>", {"class": "card-body"});
      card.append(body);

      var title = $("<h5>", {
        "class": "card-title",
        "text": strategy.fullscreentitle
      });
      body.append(title);

      var text = $("<div>", {
        "class": "card-text",
        "text": strategy.fullscreensubtitle
      });
      body.append(text);

      // var footer = $("<div>", {"class": "card-footer"});
      // card.append(footer);

      // var update = $("<div>", {
      //   "class": "text-muted",
      //   "text": `Last updated ${strategy}`
      // });

    });


  }); 
}